import React, { PropTypes } from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

import {
  bibShape,
  shelfItemShape,
  userIdentityShape,
  ugcCommentShape,
  ugcQuotationShape,
  ugcRatingShape,
  ugcTagShape,
  ugcVideoShape,
  ugcIOwnThisShape,
  ugcSimilarTitlesShape,
  ugcPrivateNoteShape
} from '@bibliocommons/bc-prop-types';

import BibListItem from '../../../shared/BibListItem';
import ShelfListItemBibBriefInfo from '../BibBriefInfo';
import ShelfListItemFooterInfo from '../FooterInfo';
import ShelfListItemSecondaryInfo from '../SecondaryInfo';

export class ShelfListItem extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderSecondaryInfo', 'renderFooterInfo', 'renderBibBrief');
  }

  renderBibBrief() {
    return (
      <ShelfListItemBibBriefInfo
        bib={this.props.bib}
        item={this.props.item}
        owner={this.props.owner}
        currentLibrary={this.props.currentLibrary}
        availabilityDetailActions={this.props.availabilityDetailActions} />
    );
  }

  renderSecondaryInfo() {
    return (
      <ShelfListItemSecondaryInfo
        item={this.props.item}
        owner={this.props.owner}
        shelfActions={this.props.shelfActions}
        ownerSettingForBib={this.props.ownerSettingForBib}
        shelfTransactions={this.props.shelfTransactions}
        iOwnThisActions={this.props.iOwnThisActions}
        iOwnThisTransactions={this.props.iOwnThisTransactions}
        currentUserShelfItemForBib={this.props.currentUserShelfItemForBib} />
    );
  }

  renderFooterInfo() {
    return (
      <ShelfListItemFooterInfo
        bib={this.props.bib}
        item={this.props.item}
        owner={this.props.owner}
        shelfName={this.props.shelfName}
        currentLibrary={this.props.currentLibrary}
        localBranch={this.props.localBranch}
        ownerCommentForBib={this.props.ownerCommentForBib}
        ownerQuotationsForBib={this.props.ownerQuotationsForBib}
        ownerTagsForBib={this.props.ownerTagsForBib}
        ownerRatingForBib={this.props.ownerRatingForBib}
        ownerVideoForBib={this.props.ownerVideoForBib}
        ownerSimilarTitlesForBib={this.props.ownerSimilarTitlesForBib}
        ownerPrivateNoteForBib={this.props.ownerPrivateNoteForBib}
        similarTitleBibs={this.props.similarTitleBibs}
        commentsTransactions={this.props.commentsTransactions}
        quotationsTransactions={this.props.quotationsTransactions}
        ratingsTransactions={this.props.ratingsTransactions}
        shelfTransactions={this.props.shelfTransactions}
        tagsTransactions={this.props.tagsTransactions}
        videosTransactions={this.props.videosTransactions}
        similarTitlesTransactions={this.props.similarTitlesTransactions}
        privateNotesTransactions={this.props.privateNotesTransactions}
        ratingsActions={this.props.ratingsActions}
        commentsActions={this.props.commentsActions}
        quotationsActions={this.props.quotationsActions}
        tagsActions={this.props.tagsActions}
        videosActions={this.props.videosActions}
        similarTitlesActions={this.props.similarTitlesActions}
        shelfActions={this.props.shelfActions}
        privateNotesActions={this.props.privateNotesActions} />
    );
  }

  render() {
    const { bib } = this.props;

    return (
      <BibListItem
        bib={bib.get('briefInfo')}
        className="cp-shelf-list-item"
        renderBibBrief={() => this.renderBibBrief()}
        renderInfo={() => this.renderSecondaryInfo()}
        renderFooterInfo={() => this.renderFooterInfo()} />
    );
  }
}

ShelfListItem.propTypes = {
  currentLibrary: ImmutablePropTypes.map.isRequired,
  owner: userIdentityShape.isRequired,
  item: shelfItemShape.isRequired,
  bib: bibShape.isRequired,
  shelfName: PropTypes.string.isRequired,
  localBranch: PropTypes.string,
  currentUserShelfItemForBib: shelfItemShape,
  ownerCommentForBib: ugcCommentShape,
  ownerQuotationsForBib: ImmutablePropTypes.listOf(ugcQuotationShape),
  ownerRatingForBib: ugcRatingShape,
  ownerTagsForBib: ImmutablePropTypes.listOf(ugcTagShape),
  ownerVideoForBib: ugcVideoShape,
  ownerSimilarTitlesForBib: ImmutablePropTypes.listOf(ugcSimilarTitlesShape),
  ownerPrivateNoteForBib: ugcPrivateNoteShape,
  ownerSettingForBib: ugcIOwnThisShape,
  similarTitleBibs: ImmutablePropTypes.map.isRequired,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  ratingsTransactions: ImmutablePropTypes.map.isRequired,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  iOwnThisTransactions: ImmutablePropTypes.map.isRequired,
  similarTitlesTransactions: ImmutablePropTypes.map.isRequired,
  privateNotesTransactions: ImmutablePropTypes.map.isRequired,
  tagsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ratingsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  similarTitlesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  iOwnThisActions: PropTypes.objectOf(PropTypes.func).isRequired,
  privateNotesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};

ShelfListItem.defaultProps = {
  bib: Immutable.Map()
};

export default ShelfListItem;



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/ShelfListItem/ShelfListItem.jsx